// src/reducers/farmacovigilanciaReducers.js

const dadosUnidadeSaude = (state = {}, action) => {
  if (action.type === 'dadosUnidadeSaude') return action.payload;
  if (action.type === 'RESET_FARMACOVIGILANCIA') return {};
  if (action.type === 'UPDATE_DADOS_UNIDADE_SAUDE') return {
    ...state,
    ...action.payload
  };
  return state;
};

const dadosNotificador = (state = {}, action) => {
  if (action.type === 'dadosNotificador') return action.payload;
  if (action.type === 'RESET_FARMACOVIGILANCIA') return {};
  return state;
};

const dadosEfeitosIndesejados = (state = {}, action) => {
  if (action.type === 'dadosEfeitosIndesejados') return action.payload;
  if (action.type === 'RESET_FARMACOVIGILANCIA') return {};
  if (action.type === 'UPDATE_DADOS_EFEITOS_INDESEJADOS') return {
    ...state,
    ...action.payload
  };
  return state;
};

const dadosEvolucaoTratamento = (state = {}, action) => {
  if (action.type === 'dadosEvolucaoTratamento') return action.payload;
  if (action.type === 'RESET_FARMACOVIGILANCIA') return {};
  return state;
};

const informacoesMedicamento = (state = {}, action) => {
  if (action.type === 'informacoesMedicamento') return action.payload;
  if (action.type === 'RESET_FARMACOVIGILANCIA') return {};
  return state;
};

const dadosPaciente = (state = {}, action) => {
  if (action.type === 'dadosPaciente') return action.payload;
  if (action.type === 'RESET_FARMACOVIGILANCIA') return {};
  return state;
};

export {
  dadosUnidadeSaude,
  dadosNotificador,
  dadosEfeitosIndesejados,
  dadosEvolucaoTratamento,
  informacoesMedicamento,
  dadosPaciente,
};
